module.exports = __webpack_public_path__ + "img/verf-zwart.0ca44d31.jpeg";